import { useEffect, useRef } from 'react';
export default function useContentResizeObserver(dialogRef, ignoreContentObserver, centerDialog) {
  const contentResizeObserver = useRef(null);
  useEffect(() => {
    const dialog = dialogRef.current;
    if (!dialog || ignoreContentObserver) return;
    let resizeTimer = null;
    let isThrottling = false;
    contentResizeObserver.current = new ResizeObserver(() => {
      if (isThrottling) return;
      isThrottling = true;
      if (resizeTimer) window.cancelAnimationFrame(resizeTimer);
      resizeTimer = window.requestAnimationFrame(() => {
        centerDialog();
        resizeTimer = null;
        isThrottling = false;
      });
    });
    contentResizeObserver.current.observe(dialog);
    return () => {
      contentResizeObserver.current?.disconnect();
      contentResizeObserver.current = null;
      if (resizeTimer) window.cancelAnimationFrame(resizeTimer);
    };
  }, [dialogRef, ignoreContentObserver, centerDialog]);
}
//# sourceMappingURL=useContentResizeObserver.js.map